//  引入axios文件包
import axios from 'axios'
import common from '@/config/common.js'
import { Notification, MessageBox, Message, Loading } from 'element-ui';
import cache from '@/plugins/cache'
import errorCode from '@/utils/errorCode'
import { tansParams, blobValidate } from '@/utils/ruoyi.js';



// 是否显示重新登录
export let isRelogin = { show: false };

//创建一个新的请求实例
const request = axios.create({
	baseURL: common.url, //请求路径
	header: {
	  //'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
	  'content-type': 'application/json;charset=utf-8'
	},
	timeout: 36000 //请求超时
});

//添加请求拦截器---给请求添加请求头添加token令牌
request.interceptors.request.use(function(config) {
	// 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
	// 是否需要防止数据重复提交
	const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
	// 在发送请求之前做些什么
    /* if (localStorage.getItem("token")) {
       config.headers['token'] = localStorage.getItem("token");
    } */
	if (localStorage.getItem("token") && !isToken) {
	   //config.headers['token'] = 'pxxt ' + token;
	   config.headers['token'] = localStorage.getItem("token");
	}
	
	
	// get请求映射params参数
	if (config.method === 'get' && config.params) {
	    let url = config.url + '?' + tansParams(config.params);
	    url = url.slice(0, -1);
	    config.params = {};
	    config.url = url;
	}
	
	if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
	    const requestObj = {
	      url: config.url,
	      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
	      time: new Date().getTime()
	    }
	    const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
	    const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
	    if (requestSize >= limitSize) {
	      console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
	      return config;
	    }
	    const sessionObj = cache.session.getJSON('sessionObj')
	    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
	      cache.session.setJSON('sessionObj', requestObj)
	    } else {
	      const s_url = sessionObj.url;                  // 请求地址
	      const s_data = sessionObj.data;                // 请求数据
	      const s_time = sessionObj.time;                // 请求时间
	      const interval = 1000;                         // 间隔时间(ms)，小于此时间视为重复提交
	      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
	        const message = '数据正在处理，请勿重复提交';
	        console.warn(`[${s_url}]: ` + message)
	        return Promise.reject(new Error(message))
	      } else {
	        cache.session.setJSON('sessionObj', requestObj)
	      }
	    }
	}
	return config;
}, function(error) {
	// 对请求错误做些什么
	console.log(error);
	Message.error('网络请求超时，请稍后重试...')
	return Promise.reject(error);
});

//添加响应拦截器
request.interceptors.response.use(function(res) {
	// 未设置状态码则默认成功状态
	const code = res.data.code || 200;
    // 获取错误信息
	const msg = errorCode[code] || res.data.msg || errorCode['default']
	// 二进制数据则直接返回
	if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
	    return res.data
	}
	if (code === 401) {
		if (!isRelogin.show) {
			var  bol = confirm('登录状态已过期，您可以继续留在该页面，或者重新登录!', '登录提醒', {
			        distinguishCancelAndClose: true,
					type:'warning ' ,
			        confirmButtonText: '去登录',
			        cancelButtonText: '取消'
			   })
			   if(bol ==true){
				   location.href = '#/user/login';	
			   }
			   //.then(() => {
					//跳转到试学
				//	location.href = '#/user/login';							
			       //alert("试学！");
			   //}).catch(action => {
			       //console.log("取消所属")
			  // });
			/* this.$confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', {
				confirmButtonText: '重新登录',
				callback: action => {
				    isRelogin.show = false;
				    localStorage.clear();
				    
				}
			}); */
		}
		
	    return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
	} else if (code === 500) {
	      Message({ message: msg, type: 'error' })
	      return Promise.reject(new Error(msg))
	    } else if (code === 601) {
	      Message({ message: msg, type: 'warning' })
	      return Promise.reject('error')
	    } else if (code !== 200) {
	      Notification.error({ title: msg })
	      return Promise.reject('error')
	    } else {
	      return res.data
	    }
	/* } */	  
	/* if (code === 401) {
	      if (!isRelogin.show) {
	        isRelogin.show = true;
	        MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', { confirmButtonText: '重新登录', cancelButtonText: '取消', type: 'warning' }).then(() => {
	          isRelogin.show = false;
	          store.dispatch('LogOut').then(() => {
	            location.href = '/index';
	          })
	      }).catch(() => {
	        isRelogin.show = false;
	      });
	    }
	      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
	} */	
		
   /* var me =this;
	var obj = obj = response.data;
	if (obj.code == '200') {
		return obj;
	}
	if (obj.code == '401') {
		//Message.error('登录信息已过期');
		localStorage.clear();
		location.href = '#/user/login';
        return;
	}
	if (obj.code == '500') {
		//Message.error(obj.msg);
		return obj;
	} */
	
}, function(error) {
	console.log('err' + error)
	let { message } = error;
	if (message == "Network Error") {
	    message = "后端接口连接异常";
	} else if (message.includes("timeout")) {
	    message = "系统接口请求超时";
	} else if (message.includes("Request failed with status code")) {
	    message = "系统接口" + message.substr(message.length - 3) + "异常";
	}
	Message({ message: message, type: 'error', duration: 5 * 1000 })
	return Promise.reject(error)
});

export default request